import { render, staticRenderFns } from "./sportsDetail_inforPanel.vue?vue&type=template&id=4980a492&scoped=true"
import script from "./sportsDetail_inforPanel.vue?vue&type=script&lang=js"
export * from "./sportsDetail_inforPanel.vue?vue&type=script&lang=js"
import style0 from "./sportsDetail_inforPanel.vue?vue&type=style&index=0&id=4980a492&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4980a492",
  null
  
)

export default component.exports